import { MailOutlined } from '@ant-design/icons'
import { NetworkStatus } from '@apollo/client'
import { Result } from 'antd'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { AppHeader, ColumnLayout } from '@/components'
import { useIsFeatureToggleOn } from '@/components/feature-toggle/feature-toggle.hooks'
import { useGetAnniversaryCardsQuery, useGetViewerQuery } from '@/generated/graphql'

import { AnniversaryCards } from './anniversary-card-management.component'
import s from './anniversary-card.module.less'

export const AnniversaryCardManagementContainer: React.FC = () => {
  const fetchCount = 1000
  const anniversary = moment().format('YYYY')
  const { t } = useTranslation()

  const isFeatureToggleOn = useIsFeatureToggleOn('anniversaryCard')

  const { data: viewerData } = useGetViewerQuery({
    skip: !isFeatureToggleOn,
    variables: {
      withIsAnniversaryCardCreator: true,
    },
  })

  const leaderEmail = viewerData?.viewer.email || ''
  const creatorUserId = viewerData?.viewer.userId || 0
  const isAnniversaryCardCreator = viewerData?.viewer.isAnniversaryCardCreator

  const { data, networkStatus, loading } = useGetAnniversaryCardsQuery({
    skip: !isAnniversaryCardCreator || !leaderEmail || !creatorUserId,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      leaderEmail,
      creatorUserId,
      pagination: {
        last: fetchCount,
      },
      anniversary,
      withFinished: true,
      withUnfinished: true,
      withBlocked: true,
    },
    notifyOnNetworkStatusChange: true,
  })

  if (!isFeatureToggleOn || !viewerData) {
    return null
  }

  const header = (
    <AppHeader
      title={t('anniversaryCard.system.title')}
      avatar={
        <span style={{ fontSize: 24 }}>
          <MailOutlined />
        </span>
      }
    ></AppHeader>
  )

  const container = isAnniversaryCardCreator ? (
    <div className={s.container}>
      <AnniversaryCards
        data={data}
        anniversary={anniversary}
        creatorUserId={creatorUserId}
        key='unfinished'
        type='unfinished'
        loading={loading}
      />
      <AnniversaryCards
        data={data}
        anniversary={anniversary}
        creatorUserId={creatorUserId}
        key='finished'
        type='finished'
        loading={loading}
      />
      <AnniversaryCards
        data={data}
        anniversary={anniversary}
        creatorUserId={creatorUserId}
        key='blocked'
        type='blocked'
        loading={networkStatus === NetworkStatus.loading}
      />
    </div>
  ) : (
    <Result status='warning' title='无权限处理周年贺卡' />
  )

  return <ColumnLayout header={header} middle={container} />
}
